<template>
  <div>
    <v-divider class="my-8" />

    <v-row>
      <v-col cols="12" md="6" v-if="appointment.meeting_location_description">
        <h6 class="text-uppercase grey--text">
          {{
            `${$t('appointment.label.meetingLocationDescription')} (${$t(
              `appointment.meetingLocation.${appointment.meeting_location}`
            )})`
          }}
        </h6>
        <span class="body-2">
          {{ appointment.meeting_location_description }}
        </span>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.additionalValue') }}:
        </h6>
        <span class="body-2">
          {{
            appointment.additionals
              ? formatCurrency(appointment.additionals[0].value)
              : '---'
          }}
        </span>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.needsAuthorization.question') }}
          <InformationTooltip
            :message="$t('appointment.needsAuthorizationInfo')"
          />
        </h6>
        <span class="body-2">
          {{
            appointment.needs_authorization
              ? $t('appointment.label.needsAuthorization.yes')
              : $t('appointment.label.needsAuthorization.no')
          }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <h6 class="text-uppercase grey--text">
          {{
            `${$t('appointment.label.keyLocationDescription')} (${$t(
              `appointment.keyLocation.${appointment.key_location}`
            )})`
          }}
        </h6>
        <span class="body-2">
          {{ appointment.key_location_description }}
        </span>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.keyPicker') }}:
        </h6>
        <span class="body-2">
          {{ $t(`appointment.keyPicker.${appointment.key_picker}`) }}
        </span>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.observations') }}
        </h6>
        <span class="body-2">
          {{ appointment.observations ? appointment.observations : '---' }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { catalogMonetary } from '@/util/catalog'

import InformationTooltip from '@/components/app/InformationTooltip'

export default {
  name: 'AppointmentMeetingInfo',

  components: {
    InformationTooltip,
  },

  props: {
    appointment: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formatCurrency: catalogMonetary,
    }
  }
}
</script>
